// extracted by mini-css-extract-plugin
export var layoutContainer = "_ap-0";
export var layoutContainerNoRounding = "_ap-6";
export var layoutContainerOpen = "_ap-5";
export var layoutContainerResizing = "_ap-1";
export var mainContent = "_ap-2";
export var resizeDivider = "_ap-3";
export var slidePanel = "_ap-4";